import { cn } from '@c2fo/liquidity';

const NavigationBar = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return (
    <div
      className={cn('pointer-events-auto z-10 w-full bg-white shadow-[rgba(13,10,44,0.2)_7px_0px_20px_0px]', className)}
    >
      <div className="mx-auto max-w-screen-xl px-4 py-6 lg:px-6">{children}</div>
    </div>
  );
};

export default NavigationBar;
